<template>
  <q-page class="ub-page">
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-lg">
        <div class="text-h3">Typography</div>
      </div>
    </div>
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-md">
        <div class="text-body1">
          Typography by <a href="https://quasar.dev/">Quasar</a>. See detailed documentation at
          <a href="https://quasar.dev/style/typography">https://quasar.dev/style/typography</a>
        </div>
      </div>
    </div>
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-md">
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-h1</div>
            <div role="alert" class="q-ml-sm q-badge flex inline items-center no-wrap q-badge--single-line bg-secondary">h1</div>
          </div>
          <div class="col-sm-9 col-12 text-h1">Dashblocks</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-h2</div>
            <div role="alert" class="q-ml-sm q-badge flex inline items-center no-wrap q-badge--single-line bg-secondary">h2</div>
          </div>
          <div class="col-sm-9 col-12 text-h2">Dashblocks</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-h3</div>
            <div role="alert" class="q-ml-sm q-badge flex inline items-center no-wrap q-badge--single-line bg-secondary">h3</div>
          </div>
          <div class="col-sm-9 col-12 text-h3">Dashblocks</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-h4</div>
            <div role="alert" class="q-ml-sm q-badge flex inline items-center no-wrap q-badge--single-line bg-secondary">h4</div>
          </div>
          <div class="col-sm-9 col-12 text-h4">Dashblocks</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-h5</div>
            <div role="alert" class="q-ml-sm q-badge flex inline items-center no-wrap q-badge--single-line bg-secondary">h5</div>
          </div>
          <div class="col-sm-9 col-12 text-h5">Dashblocks Material Admin Template</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-h6</div>
            <div role="alert" class="q-ml-sm q-badge flex inline items-center no-wrap q-badge--single-line bg-secondary">h6</div>
          </div>
          <div class="col-sm-9 col-12 text-h6">Dashblocks Material Admin Template</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-subtitle1</div>
            <!---->
          </div>
          <div class="col-sm-9 col-12 text-subtitle1">Dashblocks Material Admin Template</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-subtitle2</div>
            <!---->
          </div>
          <div class="col-sm-9 col-12 text-subtitle2">Dashblocks Material Admin Template</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-body1</div>
            <!---->
          </div>
          <div class="col-sm-9 col-12 text-body1">
            Dashblocks enables easily creating sophisticated interactive dashboards simply by declaring dashboard structure as json or javascript object.
          </div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-body2</div>
            <!---->
          </div>
          <div class="col-sm-9 col-12 text-body2">
            Dashblocks uses popular charting libraries to render charts: d3, Chart.js, Dygraphs, Plotly.js.
          </div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-caption</div>
            <!---->
          </div>
          <div class="col-sm-9 col-12 text-caption">Caption text</div>
        </div>
        <div class="row items-center q-mb-lg">
          <div class="col-sm-3 col-12">
            <div role="alert" class="q-badge flex inline items-center no-wrap q-badge--single-line bg-primary">text-overline</div>
            <!---->
          </div>
          <div class="col-sm-9 col-12 text-overline">Overline</div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'DashblocksTypography',
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
